/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateActivityRequest
 */
export interface CreateActivityRequest {
    /**
     * The <code>id</code> of an existing record in the cars table.
     * @type {string}
     * @memberof CreateActivityRequest
     */
    carId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityRequest
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityRequest
     */
    summary: string;
    /**
     * Must not be greater than 255 characters.
     * @type {string}
     * @memberof CreateActivityRequest
     */
    locationName?: string | null;
    /**
     * Must be between -90 and 90.
     * @type {number}
     * @memberof CreateActivityRequest
     */
    lat?: number | null;
    /**
     * Must be between -180 and 180.
     * @type {number}
     * @memberof CreateActivityRequest
     */
    lng?: number | null;
    /**
     * Must be a valid date.
     * @type {string}
     * @memberof CreateActivityRequest
     */
    scheduledAt?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateActivityRequest
     */
    isPublic?: boolean;
}

/**
 * Check if a given object implements the CreateActivityRequest interface.
 */
export function instanceOfCreateActivityRequest(value: object): value is CreateActivityRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    return true;
}

export function CreateActivityRequestFromJSON(json: any): CreateActivityRequest {
    return CreateActivityRequestFromJSONTyped(json, false);
}

export function CreateActivityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateActivityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'carId': json['car_id'] == null ? undefined : json['car_id'],
        'type': json['type'],
        'summary': json['summary'],
        'locationName': json['location_name'] == null ? undefined : json['location_name'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'scheduledAt': json['scheduled_at'] == null ? undefined : json['scheduled_at'],
        'isPublic': json['is_public'] == null ? undefined : json['is_public'],
    };
}

export function CreateActivityRequestToJSON(json: any): CreateActivityRequest {
    return CreateActivityRequestToJSONTyped(json, false);
}

export function CreateActivityRequestToJSONTyped(value?: CreateActivityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'car_id': value['carId'],
        'type': value['type'],
        'summary': value['summary'],
        'location_name': value['locationName'],
        'lat': value['lat'],
        'lng': value['lng'],
        'scheduled_at': value['scheduledAt'],
        'is_public': value['isPublic'],
    };
}

